import { FC } from "react";
import { Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

import { RoutesMap } from "../../../../routes.tsx";

interface Props {
  isProductStatusChanging?: boolean;
}

export const ToPaymentsButton: FC<Props> = ({ isProductStatusChanging }) => {
  const navigate = useNavigate();

  return (
    <Button
      w="100%"
      mt="8px"
      colorScheme="purple"
      isDisabled={isProductStatusChanging}
      onClick={() => { navigate(RoutesMap.paymentsSchedule); }}
    >
      К платежам
    </Button>
  );
};
